import React, { useContext, useState } from "react";
import { sidebarcontext } from "../../context/Sidebarcontext";
import { MapContainer, TileLayer, ZoomControl } from "react-leaflet";
import MapsLayers from "./MapsLayers/MapsLayers";

export default function Map({
	children,
	maxZoom,
	minZoom,
	zoomAnimation,
	maxNativeZoom,
}) {
	let { isSideOpen } = useContext(sidebarcontext);
	const [maptile, setMapTile] = useState(
		"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
	);
	const changeLayers = (layer) => {
		setMapTile(layer);
	};
	const mapClass = isSideOpen ? "map-parent-max" : "map-parent-min";
	const lang = localStorage.getItem("lang") || "en";
	return (
		<div className={mapClass}>
			<MapContainer
				id="map-container"
				center={[26.8206, 30.8025]}
				zoomControl={false}
				scrollWheelZoom={true}
				zoom={6}
				dragging={true}
				minZoom={minZoom}
				maxZoom={maxZoom}
				zoomAnimation={zoomAnimation}
				zoomSnap={0.1}
				className="map-container"
			>
				<ZoomControl position={lang === "ar" ? "bottomleft" : "bottomright"} />
				<TileLayer
					attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
					url={maptile}
				/>
				{children}
			</MapContainer>
			<MapsLayers handlelayers={changeLayers} />
		</div>
	);
}
